module.exports = __webpack_public_path__ + "img/njxxgc.d239d388.png";